import React from "react";
import AboutInfo from "./AboutInfo";
import Team from "./Team";
import Counter from "./Counter";
import Choose from "./Choose";
import Testimonial from "./Testimonial";
import WorkProcess from "./WorkProcess";

const About = () => {
  return (
    <div>
      <AboutInfo />
      <Counter />
      <WorkProcess />
      <Choose />
      <Testimonial />
      <Team />
    </div>
  );
};

export default About;
